export default __webpack_public_path__ + "static/media/pan-number-golden.02443796.svg";